import { ProjectContext } from "context/ProjectProvider";
import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { GET_PROJECT_WORKFLOW_TEMPLATE_NAMES } from "services/graphQL/ciq-queries";

export default function useProjectTemplateListHook(props: {
  featureId: number;
}) {
  const { featureId } = props;
  const { gqlClientForProject, eventLogs } = useContext(ProjectContext);

  const [defaultTemplateId, setDefaultTemplateId] = useState<string>();

  const {
    data: projectWorkflowTemplates,
    loading,
    refetch: refetchMDB
  } = useCIQQuery<{
    project_workflow_templates: Array<any>;
  }>(GET_PROJECT_WORKFLOW_TEMPLATE_NAMES, {
    client: gqlClientForProject,
    variables: { featureId }
  });

  const previousEventLogs = useRef(eventLogs);
  useEffect(() => {
    if (eventLogs?.length && previousEventLogs.current !== eventLogs) {
      if (
        eventLogs.some((x) => x.data_source === "project_workflow_templates")
      ) {
        refetchMDB(); // Refetching Project workflow Template data
      }
    }
    previousEventLogs.current = eventLogs;
  }, [eventLogs, refetchMDB]);

  const options = useMemo(() => {
    const tooltip = "tooltip";
    if (
      projectWorkflowTemplates &&
      projectWorkflowTemplates.project_workflow_templates
    ) {
      const templates =
        projectWorkflowTemplates.project_workflow_templates.filter(
          (template: any) => !template.disabled
        );

      setDefaultTemplateId(
        templates.find((x: { default: boolean; id: string }) => x.default)?.id
      );

      return templates.map((t) => ({
        label: t.name,
        value: t.id,
        tooltip
      }));
    }
    return undefined;
  }, [projectWorkflowTemplates]);

  return {
    options,
    loading,
    defaultTemplateId
  };
}
